import React, { useEffect, useState } from 'react';
import { Modal } from "react-bootstrap";
import { useDispatch } from 'react-redux';
import toast from 'react-hot-toast';
import { storeActivityIndicator } from '../../../../redux/reducers/authSlice';
import { YurticiMutabakatService } from '../../../../services/YurticiMutabakatService';

interface Props {
    ids: string[]
    show: boolean
    onClose: () => void
    onKaydedildi: () => void
}

/** Seçili kayıtları "İncelendi" işaretler; not zorunlu (kim, ne zaman, not saklanır). */
const IncelemeModal = ({ ids, show, onClose, onKaydedildi }: Props) => {
    const dispatch = useDispatch();
    const [not, setNot] = useState<string>('');
    const [hata, setHata] = useState<string | undefined>(undefined);

    useEffect(() => {
        setNot('');
        setHata(undefined);
    }, [show])

    const kaydet = async () => {
        if (not.trim() == '') {
            setHata('Not zorunludur.');
            toast.error('Not zorunludur.');
            return;
        }

        try {
            dispatch(storeActivityIndicator(true));

            var response = await YurticiMutabakatService.incele(ids, not.trim());

            if (!response.isSuccess) {
                toast.error(response.message ?? '');
                return;
            }

            toast.success(response.data + ' kayıt incelendi olarak işaretlendi.');
            onKaydedildi();
        } catch (error: any) {
            toast.error(error);
        } finally {
            dispatch(storeActivityIndicator(false));
        }
    }

    return (
        <Modal show={show} onHide={onClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>İncelendi işaretle ({ids.length} kayıt)</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <label htmlFor="mutabakat-inceleme-notu" className="form-label required">Not</label>
                <textarea
                    id="mutabakat-inceleme-notu"
                    className={'form-control' + (hata ? ' is-invalid' : '')}
                    rows={3}
                    value={not}
                    placeholder="Örn. Yurtiçi desi düzeltmesi, fark kabul edildi."
                    onChange={e => { setNot(e.target.value); setHata(undefined); }}
                />
                {hata && <div className="invalid-feedback d-block">{hata}</div>}
                <div className="text-muted fs-7 mt-2">Durum ya da fark sonradan değişirse işaret kendiliğinden kalkar.</div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-sm btn-light" onClick={onClose}>Vazgeç</button>
                <button className="btn btn-sm btn-primary" onClick={kaydet}>Kaydet</button>
            </Modal.Footer>
        </Modal>
    )
}

export default IncelemeModal;
